<div *ngIf="isLoadHTML" id="main" class="myw-content d-flex flex-column flex-fill">
    <div class="myw-inner myw-container py-4">
        <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="d-flex align-items-center justify-content-between mb-4">
            <h1 class="fs-20 mb-0">Executive Summary</h1>
            <a [routerLink]="['/createproposal/create']" class="btn btn-light">
                <span>Create New Opportunity</span>
            </a>
        </div>
        <div class="row myw-grid iom-summary-card mb-4">
            <div class="col-3 mb-3">
                <div class="card iom-card-item d-flex h-100">
                    <div class="card-head">
                        Number of Clients
                    </div>
                    <div class="card-body">
                        <div class="iom-list-item d-flex h-100">
                            {{clientlistLength}} </div>
                    </div>
                </div>
            </div>
            <div class="col-3 mb-3">
                <div class="card iom-card-item d-flex h-100" *ngIf="envVar.Env != 'FDS_ManualUpload'">
                    <div class="card-head">
                        Number of E2E Ids
                    </div>
                    <div class="card-body">
                        <div class="iom-list-item d-flex h-100">
                            {{proposallistLength}}
                        </div>
                    </div>
                </div>
                <div class="card iom-card-item d-flex h-100" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                    <div class="card-head">
                        Number of Opportunity Ids
                    </div>
                    <div class="card-body">
                        <div class="iom-list-item d-flex h-100">
                            {{proposallistLength}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 mb-3">
                <div class="card iom-card-item d-flex h-100">
                    <div class="card-head">
                        Number of Deepdives
                    </div>
                    <div class="card-body pr-0 pt-0">
                        <div class="iom-list-item">
                            <div class="row w-100">
                                <div class="col-4">
                                    <div class="sm-text">APP</div>
                                </div>
                                <div class="col-4">
                                    <div class="sm-text">INFRA</div>
                                </div>
                                <div class="col-4">
                                    <div class="sm-text">OTHERS</div>
                                </div>
                            </div>
                        </div>
                        <div class="iom-list-item">
                            <div class="row w-100">
                                <div class="col-4 py-2">
                                    <div class="text-center">{{AoddCount}}</div>
                                </div>
                                <div class="col-4  py-2 rgt-border">
                                    <div class="text-center">{{IoddCount}}</div>
                                </div>
                                <div class="col-4  py-2 rgt-border">
                                    <div class="text-center">{{OthersddCount}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h2 class="fs-16 text-primary myw-700 mb-4">Analysis Summary</h2>
        <div class="iom-section iom-sub-section">
            <div class="row mb-4">
                <div class="col">
                    <div class="form-control new-dropdown control-grad d-flex">
                        <label class="sr-only">Client Name</label>
                        <button type="button" class="dropdown-toggle" data-bs-display="static" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            {{selectedclientName}}
                        </button>
                        <div class="dropdown-menu">
                            <div class="dd-overflow ScrollDPY">
                                <a class="dropdown-item"
                                    [ngClass]="{'addactive': (selectedclientName == 'Select Client')}"
                                    (click)="loadProjectDetails('Select Client')">Select Client</a>
                                <a class="dropdown-item" [ngClass]="{'addactive': (client == selectedclientName)}"
                                    *ngFor="let client of DistinctClientList"
                                    (click)="loadProjectDetails(client)">{{client}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                    <div class="form-control new-dropdown control-grad d-flex">
                        <label class="sr-only">Project Name</label>
                        <button type="button" class="dropdown-toggle" data-bs-display="static" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            {{selectedprojectName}}
                        </button>
                        <div class="dropdown-menu">
                            <div class="dd-overflow ScrollDPY">
                                <a class="dropdown-item"
                                    [ngClass]="{'addactive': (selectedprojectName == 'Select Project')}"
                                    (click)="loadProposalDetails('Select Project')">Select Project</a>
                                <a class="dropdown-item" [ngClass]="{'addactive': (ProjectName == selectedprojectName)}"
                                    *ngFor="let ProjectName of ProjectDetails_FDS"
                                    (click)="loadProposalDetails(ProjectName)">{{ProjectName}}</a>
                            </div>
                        </div>
                    </div>                   
                </div>
                <div class="col">
                    <div class="form-control new-dropdown control-grad d-flex" *ngIf="envVar.Env != 'FDS_ManualUpload'">
                        <label class="sr-only">E2E Name</label>
                        <button type="button" class="dropdown-toggle" data-bs-display="static" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            {{selectedprojectName}}
                        </button>
                        <div class="dropdown-menu">
                            <div class="dd-overflow ScrollDPY">
                                <a class="dropdown-item"
                                    [ngClass]="{'addactive': (selectedprojectName == 'Select E2E')}"
                                    (click)="loadProposalDetails('Select E2E')">Select E2E</a>
                                <a class="dropdown-item" [ngClass]="{'addactive': (ProjectName == selectedprojectName)}"
                                    *ngFor="let ProjectName of FilteredProjectDetails"
                                    (click)="loadProposalDetails(ProjectName)">{{ProjectName}}</a>
                            </div>
                        </div>
                    </div>                   
                        <div class="form-control new-dropdown control-grad d-flex" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                            <label class="sr-only">Opportunity Id</label>
                            <button type="button" class="dropdown-toggle" data-bs-display="static" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                {{selectedproposalName}}
                            </button>
                            <div class="dropdown-menu">
                                <div class="dd-overflow ScrollDPY">
                                    <a class="dropdown-item"
                                        [ngClass]="{'addactive': (selectedproposalName == 'Select Opportunity')}"
                                        (click)="selectedOpportunity('Select Opportunity')">Select Opportunity</a>
                                    <a class="dropdown-item" [ngClass]="{'addactive': (Proposal == selectedproposalName)}"
                                        *ngFor="let Proposal of FilteredProposalDetails"
                                        (click)="selectedOpportunity(Proposal)">{{Proposal}}</a>
                                </div>
                            </div>
                        </div>                    
                </div>
                <!-- <div class="col">
                    <div class="form-control new-dropdown control-grad d-flex">
                        <label class="sr-only">Opportunity Id</label>
                        <button type="button" class="dropdown-toggle" data-display="static" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            {{selectedproposalName}}
                        </button>
                        <div class="dropdown-menu">
                            <div class="dd-overflow ScrollDPY">
                                <a class="dropdown-item"
                                    [ngClass]="{'addactive': (selectedproposalName == 'Select Opportunity')}"
                                    (click)="selectedOpportunity('Select Opportunity')">Select Opportunity</a>
                                <a class="dropdown-item" [ngClass]="{'addactive': (Proposal == selectedproposalName)}"
                                    *ngFor="let Proposal of FilteredProposalDetails"
                                    (click)="selectedOpportunity(Proposal)">{{Proposal}}</a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-auto">
                    <button type="button" class="btn btn-primary" (click)="onSearch()">Search</button>
                    <button type="button" class="btn btn-secondary ml-3" (click)="onReset()">Reset</button>
                </div>
            </div>
            <div class="iom-section-client-inner myw-500 iom-scroll ScrollDPY">
                <div class="iom-category-row iom-category-row-head myw-normal">
                    <div class="iom-category-col iom-category-toggle">&nbsp;</div>
                    <div class="iom-category-col iom-category-client">
                        <a href="javascript:;" class="table-sort">Client Name</a>
                    </div>
                    <div class="iom-category-col iom-category-project" *ngIf="envVar.Env != 'FDS_ManualUpload'">
                        <a href="javascript:;" class="table-sort">E2E Name</a>
                    </div>
                    <div class="iom-category-col iom-category-project" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                        <a href="javascript:;" class="table-sort">Project Name</a>
                       </div>
                    <div class="iom-category-col iom-category-proposal iom-filter" *ngIf="envVar.Env != 'FDS_ManualUpload' && envVar.Env != 'SAAS_ManualUpload'">
					 <!-- <a href="javascript:;" class="table-sort"></a> -->
					</div>
                    <div class="iom-category-col iom-category-proposal iom-filter" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                        <a href="javascript:;" class="table-sort">Opportunity</a>
                       </div>
                    <div class="iom-category-col iom-category-owner iom-filter text-center" *ngIf="envVar.Env != 'FDS_ManualUpload'">
                        <a href="javascript:;" class="table-sort">Subscription Owner</a>
                    </div>
                    <div class="iom-category-col iom-category-owner iom-filter text-center" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                        <a href="javascript:;" class="table-sort">Opportunity Owner</a>
                       </div>
                    <div class="iom-category-col iom-category-create">Create Date <span>
                            <img src="assets/images/calender-icon.svg" class="myw-icon myw-12 mr-2"
                                alt="Modify Date"></span></div>
                    <div class="iom-category-col iom-category-modify">Modify Date <span>
                            <img src="assets/images/calender-icon.svg" class="myw-icon myw-12 mr-2"
                                alt="Modify Date"></span></div>
                    <div class="iom-category-col iom-category-edit">&nbsp;</div>
                    <!-- <div class="iom-category-col iom-category-toggle">&nbsp;</div>
                    <div class="iom-category-col iom-category-client">Client Name</div>
                    <div class="iom-category-col iom-category-project">Project Name</div>
                    <div class="iom-category-col iom-category-proposal">Opportunity Id</div>
                    <div class="iom-category-col iom-category-owner text-center">Opportunity Owner</div>
                    <div class="iom-category-col iom-category-create">Create Date</div>
                    <div class="iom-category-col iom-category-modify">Modify Date</div>
                    <div class="iom-category-col iom-category-edit">&nbsp;</div> -->
                </div>
                <div class="iom-category" *ngFor="let clients of DistinctClientList1">
                    <div class="iom-category-row iom-category-head flex">
                        <div class="iom-category-col iom-category-toggle">
                            <a href="javascript:;" title="Expand/Collapse"
                                (click)="ToggleCategory($event,clients)"><span
                                    class="sr-only">Expand/Collapse</span></a>
                        </div>
                        <div class="iom-category-col iom-category-client">{{clients}}</div>
                        <div class="iom-category-col iom-category-project" style="width:100%; height: 55px;" ellipsis
                            data-bs-toggle="tooltip" title="{{loadClientProjectDetails(clients)}}">
                            {{loadClientProjectDetails(clients)}}</div>
                        <!-- <div class="iom-category-col iom-category-proposal" style="white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;" title="{{loadClientProposalDetails(clients)}}">
                            {{loadClientProposalDetails(clients)}}</div> -->
                            <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="iom-category-col iom-category-proposal" style="white-space: nowrap;
                        overflow: hidden;text-overflow: ellipsis;" title="{{loadClientProposalDetails(clients)}}">
                            {{loadClientProposalDetails(clients)}}</div>
                        <div class="iom-category-col iom-category-owner text-center">---</div>
                        <div class="iom-category-col iom-category-create">---</div>
                        <div class="iom-category-col iom-category-modify">---</div>
                        <div class="iom-category-col iom-category-edit">&nbsp;</div>
                    </div>
                    <div class="iom-subcategory" *ngIf="envVar.Env == 'SAAS_ManualUpload'">
                        <div class="iom-client" *ngFor="let prop of ProjectDetails1">
                            <div class="iom-category-row"  [ngClass]="{'disabled': prop.IsDecommRequest==1}">
                                <div class="iom-category-col iom-client-toggle" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                                    <!-- <a href="javascript:;" title="Expand/Collapse"
                                        (click)="ToggleClient($event,clients,prop)"><span
                                            class="sr-only">Expand/Collapse</span></a> -->
                                            <a href="javascript:;" title="Expand/Collapse"
                                        (click)="ToggleClient($event,clients,prop)"><span
                                            class="sr-only">Expand/Collapse</span></a>
                                </div>
                                <div class="iom-category-col iom-category-client">&nbsp;</div>
                                <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="iom-category-col iom-category-project">{{prop}}</div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload'" class="iom-category-col iom-category-project" style="width:100%;">
                                    <a [routerLink]="['/deepdive']"
                                        (click)="UpdateProposalId(prop.ProposalId, 'YES', prop.ClientName, prop.ProposalName)"
                                        style="cursor: pointer;" title="{{prop.ProposalName}}">{{getProposalName(prop.ProposalName)}}</a>
                                    </div>
                                <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="iom-category-col iom-category-proposal" style="width:100%; height: 55px;"
                                        ellipsis>
                                        {{loadProjectProposalDetails(prop,clients)}}</div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload' && envVar.Env != 'SAAS_ManualUpload'" class="iom-category-col iom-category-proposal"></div>
                                <div class="iom-category-col iom-category-owner  text-center">{{prop.CreatedByUser}}
                                </div>
                                <div class="iom-category-col iom-category-create">{{prop.CreatedOn | date :
                                    'yyyy-MM-dd'}}
                                </div>
                                <div class="iom-category-col iom-category-modify">{{prop.ModifiedOn | date :
                                    'yyyy-MM-dd'}}
                                </div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload'">
                                <div *ngIf="!prop.IsDIYUser" class="iom-category-col iom-category-edit" >
                                    <a [routerLink]="['/editproposal']" style="cursor: pointer;" (click)="UpdateProposalId(prop.ProposalId,'NO',prop.ClientName, prop.ProposalName)"
                                        class="btn btn-icon" title="Edit Opportunity" class="iom-client-edit">
                                        <img src="assets/images/edit.svg" alt="Edit" />
                                        <!-- *ngIf="onlyEdit()" -->
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </div>
                                <div *ngIf="prop.IsDIYUser" class="iom-category-col iom-category-edit">
                                    <a [routerLink]="['/editdiyproposal']" style="cursor: pointer;" (click)="UpdateProposalId(prop.ProposalId,'NO',prop.ClientName, prop.ProposalName)"
                                        class="btn btn-icon" title="Edit Opportunity" class="iom-client-edit">
                                        <img src="assets/images/edit.svg" alt="Edit" />
                                        <!-- *ngIf="onlyEdit()" -->
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </div>
                            </div>
                                <!-- <div class="iom-category-col iom-category-edit">
                                 <a [style.pointer-events]="(prop.CreatedByUser != loggedInUser) ? 'none':'auto'" 
                                     [routerLink]="['/editproposal', prop.ProposalId]"  style="cursor: pointer;" class="btn btn-icon" title="Edit">
                                         [disabled]="prop.CreatedByUser != loggedInUser" 
                                    <img src="assets/images/edit.svg" alt="Edit" class="myw-icon myw-16">
                                    <span class="sr-only">Edit</span>
                                 </a>
                                </div> -->
                            </div>
                            <div *ngIf="envVar.Env == 'FDS_ManualUpload'">
                            <div class="iom-client-details" *ngFor="let proposal of FilteredProposalDetails2">
                                <div class="iom-category-row">
                                    <div class="iom-category-col iom-client-toggle">&nbsp;</div>
                                    <div class="iom-category-col iom-category-client">&nbsp;</div>
                                    <div class="iom-category-col iom-category-project">&nbsp;</div>
                                    <div class="iom-category-col iom-category-proposal"><a [routerLink]="['/deepdive']"
                                            (click)="UpdateProposalId(proposal.ProposalId, 'YES', proposal.ClientName, proposal.ProposalName)"
                                            style="cursor: pointer;">{{proposal.ProposalName}}</a></div>
                                    <div class="iom-category-col iom-category-owner text-center">{{proposal.CreatedByUser}}</div>
                                    <div class="iom-category-col iom-category-create">
                                        {{proposal.CreatedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-modify">
                                        {{proposal.ModifiedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-edit">
                                        <a [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'"
                                            [routerLink]="['/editproposal', proposal.ProposalId]"
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                            <!-- *ngIf="onlyEdit()" -->
                                            <span class="sr-only">Edit</span>
                                        </a>
                                        <!-- <a 
                                         [routerLink]="['/editproposal',proposal.ProposalId]" style="cursor: pointer;" 
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                            <!-- *ngIf="onlyEdit()"  [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'" (click)="UpdateProposalId(proposal.ProposalId,'NO',proposal.ClientName, proposal.ProposalName)"-->
                                            <!-- <span class="sr-only">Edit</span> -->
                                        <!-- </a> --> 
                                    </div>
                                </div>
                            </div>
                        </div>
                            <!-- <div class="iom-client-details" *ngFor="let proposal of FilteredProposalDetails2">
                                <div class="iom-category-row">
                                    <div class="iom-category-col iom-client-toggle">&nbsp;</div>
                                    <div class="iom-category-col iom-category-client">&nbsp;</div>
                                    <div class="iom-category-col iom-category-project">&nbsp;</div>
                                    <div class="iom-category-col iom-category-proposal"><a [routerLink]="['/deepdive']"
                                            (click)="UpdateProposalId(proposal.ProposalId)"
                                            style="cursor: pointer;">{{proposal.ProposalName}}</a></div>
                                    <div class="iom-category-col iom-category-owner text-center">
                                        {{proposal.CreatedByUser}}</div>
                                    <div class="iom-category-col iom-category-create">
                                        {{proposal.CreatedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-modify">
                                        {{proposal.ModifiedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-edit">
                                        <a [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'"
                                            [routerLink]="['/editproposal', proposal.ProposalId]"
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                            <span class="sr-only">Edit</span>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="text-center py-3" *ngIf="isCheck">
                                <a [routerLink]="['/createproposal/create']" style="cursor: pointer;"
                                    class="btn btn-light">
                                    <img src="assets/images/create.svg" alt="Create" class="btn-img" />
                                    <span>Create New Opportunity</span>
                                </a>
                            </div> -->
                        </div>
                    </div>
                    <div class="iom-subcategory" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                        <div class="iom-client" *ngFor="let prop of ProjectDetails1_FDS">
                            <div class="iom-category-row">
                                <div class="iom-category-col iom-client-toggle" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                                    <!-- <a href="javascript:;" title="Expand/Collapse"
                                        (click)="ToggleClient($event,clients,prop)"><span
                                            class="sr-only">Expand/Collapse</span></a> -->
                                            <a href="javascript:;" title="Expand/Collapse"
                                        (click)="ToggleClient($event,clients,prop)"><span
                                            class="sr-only">Expand/Collapse</span></a>
                                </div>
                                <div class="iom-category-col iom-category-client">&nbsp;</div>
                                <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="iom-category-col iom-category-project">{{prop}}</div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload'" class="iom-category-col iom-category-project" style="width:100%;">
                                    <a [routerLink]="['/deepdive']"
                                        (click)="UpdateProposalId(prop.ProposalId, 'YES', prop.ClientName, prop.ProposalName)"
                                        style="cursor: pointer;" title="{{prop.ProposalName}}">{{getProposalName(prop.ProposalName)}}</a>
                                    </div>
                                <div *ngIf="envVar.Env == 'FDS_ManualUpload'" class="iom-category-col iom-category-proposal" style="width:100%; height: 55px;"
                                        ellipsis>
                                        {{loadProjectProposalDetails(prop,clients)}}</div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload' && envVar.Env != 'SAAS_ManualUpload'" class="iom-category-col iom-category-proposal"></div>
                                <div class="iom-category-col iom-category-owner  text-center">{{prop.CreatedByUser}}
                                </div>
                                <div class="iom-category-col iom-category-create">{{prop.CreatedOn | date :
                                    'yyyy-MM-dd'}}
                                </div>
                                <div class="iom-category-col iom-category-modify">{{prop.ModifiedOn | date :
                                    'yyyy-MM-dd'}}
                                </div>
                                <div *ngIf="envVar.Env != 'FDS_ManualUpload'">
                                <div *ngIf="!prop.IsDIYUser" class="iom-category-col iom-category-edit" >
                                    <a [routerLink]="['/editproposal']" style="cursor: pointer;" (click)="UpdateProposalId(prop.ProposalId,'NO',prop.ClientName, prop.ProposalName)"
                                        class="btn btn-icon" title="Edit Opportunity" class="iom-client-edit">
                                        <img src="assets/images/edit.svg" alt="Edit" />
                                        <!-- *ngIf="onlyEdit()" -->
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </div>
                                <div *ngIf="prop.IsDIYUser" class="iom-category-col iom-category-edit">
                                    <a [routerLink]="['/editdiyproposal']" style="cursor: pointer;" (click)="UpdateProposalId(prop.ProposalId,'NO',prop.ClientName, prop.ProposalName)"
                                        class="btn btn-icon" title="Edit Opportunity" class="iom-client-edit">
                                        <img src="assets/images/edit.svg" alt="Edit" />
                                        <!-- *ngIf="onlyEdit()" -->
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </div>
                            </div>
                                <!-- <div class="iom-category-col iom-category-edit">
                                 <a [style.pointer-events]="(prop.CreatedByUser != loggedInUser) ? 'none':'auto'" 
                                     [routerLink]="['/editproposal', prop.ProposalId]"  style="cursor: pointer;" class="btn btn-icon" title="Edit">
                                         [disabled]="prop.CreatedByUser != loggedInUser" 
                                    <img src="assets/images/edit.svg" alt="Edit" class="myw-icon myw-16">
                                    <span class="sr-only">Edit</span>
                                 </a>
                                </div> -->
                            </div>
                            <div *ngIf="envVar.Env == 'FDS_ManualUpload'">
                            <div class="iom-client-details" *ngFor="let proposal of FilteredProposalDetails2">
                                <div class="iom-category-row">
                                    <div class="iom-category-col iom-client-toggle">&nbsp;</div>
                                    <div class="iom-category-col iom-category-client">&nbsp;</div>
                                    <div class="iom-category-col iom-category-project">&nbsp;</div>
                                    <div class="iom-category-col iom-category-proposal"><a [routerLink]="['/deepdive']"
                                            (click)="UpdateProposalId(proposal.ProposalId, 'YES', proposal.ClientName, proposal.ProposalName)"
                                            style="cursor: pointer;">{{proposal.ProposalName}}</a></div>
                                    <div class="iom-category-col iom-category-owner text-center">{{proposal.CreatedByUser}}</div>
                                    <div class="iom-category-col iom-category-create">
                                        {{proposal.CreatedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-modify">
                                        {{proposal.ModifiedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-edit">
                                        <a [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'"
                                            [routerLink]="['/editproposal', proposal.ProposalId]"
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                            <!-- *ngIf="onlyEdit()" -->
                                            <span class="sr-only">Edit</span>
                                        </a>
                                        <!-- <a 
                                         [routerLink]="['/editproposal',proposal.ProposalId]" style="cursor: pointer;" 
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                           *ngIf="onlyEdit()"  [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'" (click)="UpdateProposalId(proposal.ProposalId,'NO',proposal.ClientName, proposal.ProposalName)"-->
                                            <!-- <span class="sr-only">Edit</span> -->
                                        <!-- </a> --> 
                                    </div>
                                </div>
                            </div>
                        </div>
                            <!-- <div class="iom-client-details" *ngFor="let proposal of FilteredProposalDetails2">
                                <div class="iom-category-row">
                                    <div class="iom-category-col iom-client-toggle">&nbsp;</div>
                                    <div class="iom-category-col iom-category-client">&nbsp;</div>
                                    <div class="iom-category-col iom-category-project">&nbsp;</div>
                                    <div class="iom-category-col iom-category-proposal"><a [routerLink]="['/deepdive']"
                                            (click)="UpdateProposalId(proposal.ProposalId)"
                                            style="cursor: pointer;">{{proposal.ProposalName}}</a></div>
                                    <div class="iom-category-col iom-category-owner text-center">
                                        {{proposal.CreatedByUser}}</div>
                                    <div class="iom-category-col iom-category-create">
                                        {{proposal.CreatedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-modify">
                                        {{proposal.ModifiedOn | date : 'yyyy-MM-dd'}}</div>
                                    <div class="iom-category-col iom-category-edit">
                                        <a [style.pointer-events]="(proposal.CreatedByUser != loggedInUser) ? 'none':'auto'"
                                            [routerLink]="['/editproposal', proposal.ProposalId]"
                                            style="cursor: pointer;" class="btn btn-icon" title="Edit Opportunity"
                                            class="iom-client-edit">
                                            <img src="assets/images/edit.svg" alt="Edit" />
                                            <span class="sr-only">Edit</span>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="text-center py-3" *ngIf="isCheck">
                                <a [routerLink]="['/createproposal/create']" style="cursor: pointer;"
                                    class="btn btn-light">
                                    <img src="assets/images/create.svg" alt="Create" class="btn-img" />
                                    <span>Create New Opportunity</span>
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="iom-section-client-inner d-flex justify-content-end">
                <button type="button" class="btn btn-secondary ml-3" [disabled]="this.currentPage == 1" (click)="prevPage();">Previous</button>
                <button type="button" class="btn btn-secondary ml-3" [disabled]="this.currentPage == this.totalPage" (click)="nextPage();">Next</button>
            </div> 
        </div>      
    </div>
</div>
